import Errors from './errors';

export default class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data, options = {}) {
        this.originalData = data;

        for (let field in data) {
            this[field] = data[field];
        }

        let defaultOptions = {
            hasFiles: false,
            withFormData: false
        };

        this.options = { ...defaultOptions, ...options };
        this.errors = new Errors();
    }

    /**
     * Prepare a simple Axios submittable array for the request.
     */
    simpleData() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }

    /**
     * Prepare a "FormData" object as per the submitted data.
     */
    formData() {
        let formData = new FormData();

        for (let property in this.originalData) {
            if (this[property] !== null && this[property] !== undefined) {
                if (Array.isArray(this[property])) {
                    this._appendArray(formData, property, this[property]);
                } else {
                    formData.append(property, this[property]);
                }
            }
        }

        return formData;
    }

    /**
     * Convert the submitted array to FormData flavored
     * array for submission.
     *
     * @param {FormData} formData
     * @param {string} field
     * @param {array} value
     */
    _appendArray(formData, field, value) {
        value.forEach(item => {
            formData.append(`${field}[]`, item);
        });
    }

    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();
    }

    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url) {
        return this.submit('post', url);
    }

    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('put', url);
    }

    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit('patch', url);
    }

    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit('delete', url);
    }

    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
        let headers = {};

        if (this.options.hasFiles) {
            headers['Content-Type'] = 'multipart/form-data';
        }

        return new Promise((resolve, reject) => {
            axios[requestType](url, this.options.withFormData ? this.formData() : this.simpleData(), { headers: headers })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.data.errors !== undefined && error.response.data.errors !== null) {
                        this.onFail(error.response.data.errors);
                    }

                    reject(error);
                });
        });
    }

    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess() {
        this.reset();
    }

    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        this.errors.record(errors);
    }
}
